import React, { useState, useEffect } from "react";
import { useFetch } from "../../../../../hooks/useFetch";
import { useMessage } from "../../../../../hooks/UseMessage";
import { GetFullURL } from "../../../../../CommonComponents/GlobalConfFiles/URLs";
import { LoadingScreen } from "../../../../../CommonComponents/LoadingScreen/index";
import MessageLog from "../../../../../CommonComponents/Messages/MessageLog";
import Cookies from "js-cookie";
import { useSelector } from "react-redux";
import { ReactComponent as ReactSulfurCard } from "../../../../../Assets/NewIconsForCards/Sulfur.svg";
import { ReactComponent as ReactCokeCard } from "../../../../../Assets/NewIconsForCards/PetroleumCoke.svg";
import { ReactComponent as ReactTruckScaleCard } from "../../../../../Assets/NewIconsForCards/TruckScaleIcon.svg";
import Card from "../../../../../Home/Components/Card";

export default function ScaleStation(props) {
  const [usedStation, setUsedStation] = useState();

  const userState = useSelector((state) => state.User.user);

  const language = userState.preferredLanguage;
  const userStation = userState.stationId;

  const [_createErrorMessage, _errorMessages, _setErorMessages] = useMessage();
  const [
    _getStationData,
    _stationData,
    ,
    _errorStationData,
    _setErrorStationData,
    _successStationData,
    _setSuccessStationData,
    _loadingStationData,
  ] = useFetch(GetFullURL("GetStation"), { method: "POST" });

  const operationLoading = _loadingStationData;
  let storedCookie;

  useEffect(() => {
    let usedStation = "";
    storedCookie = Cookies.get("station");

    if (!userStation) {
      if (!storedCookie) {
        _createErrorMessage("1");
        return;
      }
    }
    usedStation = storedCookie ? storedCookie : userStation;

    setUsedStation(usedStation);
    _getStationData({ data: { stationId: usedStation } });
  }, []);

  function clearMessages(e) {
    let type = e.target.dataset.type;
    switch (type) {
      case "success":
        _setSuccessStationData([]);
        break;
      case "error":
        _setErrorStationData([]);
        _setErorMessages([]);
        break;
      default:
        break;
    }
  }

  const Arr = [
    {
      title: "Sulfur",
      text: "Sulfur",
      Icon: ReactSulfurCard,
      link: "/SulfurOverview",
    },
    {
      title: "Petroleum Coke",
      text: "Petroleum Coke",
      Icon: ReactCokeCard,
      link: "/TerminalActivity/CheckinV2/COKE-ELDO",
    },
    {
      title: "Scale State",
      text: "Scale State",
      Icon: ReactTruckScaleCard,
      link: "/TerminalActivity/MTScaleState",
    },
  ];

  return (
    <div className="container-fluid ">
      {operationLoading && <LoadingScreen />}
      <div className="mainContainer">
        <div className="overviewCardContainer">
          {Arr.map((record, i) => (
            <Card {...record} key={i} />
          ))}
        </div>
      </div>
      <MessageLog
        errorMessages={[..._errorStationData, ..._errorMessages]}
        successMessages={[..._successStationData]}
        clearMessages={clearMessages}
      ></MessageLog>
    </div>
  );
}
